import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { List } from '@styled-icons/evaicons-solid/List';
import { MessageSquareAdd } from '@styled-icons/boxicons-regular/MessageSquareAdd';

//Compoments
import DashboardMenu from '../../components/dashboard/DashboardMenu';
import Header from '../../components/layouts/header';
import Body from '../../components/layouts/body';
import EventoLista from '../../components/dashboard/EventoLista';
import FormEventos from '../../components/forms/FormEventos';


//Actions
import { eventoselecionado } from '../../../../actions/eventos/eventos';

//Helpers
import { TelaModalLivre } from '../../../../helpers/TelaModal';

class Evento extends React.Component {

    state = {
        pesquisaevento: false,
        formCad: false
    }

    componentDidMount(){        
        this.props.eventoselecionado({});
    }

    handleCloseModal = () => {
        this.setState({
            pesquisaevento: !this.state.pesquisaevento?true:false
        })
    }

    handleFormCad = () => {
        this.setState({
            formCad: !this.state.formCad?true:false
        })
    }

    handleEditFormCad = () => {
        this.setState({
            formCad: true
        })
    }
    
    render() {
        return (
            <>   
            <TelaModalLivre show={this.state.pesquisaevento} handleCloseModal={this.handleCloseModal} titulo="Pesquisa Evento Cadastrados">
                <EventoLista {...this.props} handleCloseModal={this.handleCloseModal} handleEditFormEvento={this.handleEditFormCad} />
            </TelaModalLivre>         
            <DashboardMenu />            
            <Header titulo="Eventos" subtitulo="Cadastro de Eventos" descricao="" />
            <Body>
                <Button variant="outline-info" className="mb-4" size="lg" block onClick={this.handleCloseModal}>
                    <List size="30" />
                    Eventos Cadastrados
                </Button>
                {this.state.formCad?
                <FormEventos  {...this.props} idpromotora={this.props.idpromotora} />
                :
                <Button variant="primary" className="mb-4" size="lg" block onClick={this.handleFormCad}>
                    <MessageSquareAdd size="30" />
                    Novo
                </Button>
                }
            </Body>
            </>
        )
    }
}

const mapStateToProps = (state) => {    
    return {        
        idpromotora: state.reducerEventoSelecionado.idpromotora
    }
}

export default connect(mapStateToProps,{eventoselecionado})(withRouter(Evento));